import type { ComputedRef, InjectionKey } from 'vue';

export type NxChoiceValue = string | number;

export interface NxChoiceTileContext {
  multiple: ComputedRef<boolean>;
  isSelected: (value: NxChoiceValue) => boolean;
  toggle: (value: NxChoiceValue) => void;
  /** Whether this tile is the group's tab stop (roving tabindex in single mode). */
  isTabStop: (value: NxChoiceValue) => boolean;
  register: (value: NxChoiceValue, disabled: () => boolean) => () => void;
}

export const choiceTileContextKey: InjectionKey<NxChoiceTileContext> = Symbol('nx-choice-tile');
